<template>
  <div class="wapper">
    <el-container style="100%">
      <el-main style="background: #fff">
        <div class="table-wrap" v-show="listShow">
          <div class="handle-box3">
            <el-form
                :inline="true"
                ref="form"
                :model="searchForm"
                class="demo-form-inline"
            >
              <div class="uers-left">
                <el-form-item label="搜索：">
                  <el-input
                      v-model="searchForm.name"
                      placeholder="名称"
                  ></el-input>
                </el-form-item>
                <el-form-item label="类型：">
                  <el-select v-model="searchForm.type" placeholder="选择类型">
                    <el-option
                        v-for="(type, index) in types"
                        :label="type.name"
                        :key="index"
                        :value="type.value"
                    >{{ type.name }}
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-button
                    type="primary"
                    icon="el-icon-search"
                    @click="searchSubmit()"
                >搜索
                </el-button
                >
              </div>
              <div class="uers-right">
                <span class="btn-r">
                  <el-button
                      type="primary"
                      plain
                      icon="el-icon-plus"
                      @click="addSubmit"
                  >新增</el-button
                  >
                </span>
              </div>
            </el-form>
          </div>
          <div class="tabbox">
            <el-table
                :data="dataList"
                height="100%"
                border
                class="tabbox"
                ref="multipleTable"
                :header-cell-style="{ background: '#f2f6fc', color: '#606266' }"
                @selection-change="handleSelectionChange"
            >
              <el-table-column
                  type="selection"
                  width="55"
                  align="center"
              ></el-table-column>
              <el-table-column
                  prop="name"
                  label="名称"
                  width="320"
                  align="center"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.name }}</span>
                </template>
              </el-table-column>
              <el-table-column
                  prop="type"
                  width="300"
                  label="类型"
                  align="center"
              >
                <template slot-scope="scope">
                  <span>{{ getType(scope.row.type) }}</span>
                </template>
              </el-table-column>
              <el-table-column
                  prop="createDate"
                  width="250"
                  label="创建时间"
                  align="center"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.createDate }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button
                      type="text"
                      @click="handleEdit(scope.$index, scope.row)"
                  >编辑
                  </el-button
                  >
                  <el-button
                      type="text"
                      class="red"
                      @click="handleDelete(scope.$index, scope.row)"
                  >删除
                  </el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="fb">
            <el-pagination
                class="pag"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[5, 10, 15, 20, 50, 100]"
                :page-size="pagesize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                background
            ></el-pagination>
          </div>
        </div>
        <DeleteDialog
            :delVisible="delVisible"
            @deleteData="deleteData"
            @handleCloseVisible="handleCloseVisible"
        ></DeleteDialog>
        <EditSource
            :editShow="editShow"
            :editData="editData"
            @backFunStu="getFunStu"
        ></EditSource>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import EditSource from "../../components/major/EditLabel";
import DeleteDialog from "../../components/public/DeleteConfim";

var types = [
  {name: "全部", value: "0"},
  {name: "酒店", value: "13"},
  {name: "房间", value: "14"},
  {name: "展馆", value: "-1"},
  {name: "展位", value: "-2"},
  {name: "组委会", value: "1"},
  {name: "展商", value: "2"},
  {name: "展团/代表团", value: "3"},
  {name: "观众", value: "4"},
  {name: "媒体", value: "5"},
  {name: "嘉宾", value: "6"},
  {name: "搭建商", value: "7"},
  {name: "服务商", value: "8"},
  {name: "撤展人员", value: "9"},
  {name: "兼职/志愿者/外协", value: "10"},
  {name: "会议/论坛/活动", value: "11"},
  {name: "其他", value: "12"},
];

export default {
  data() {
    return {
      total: 0, //总条数
      currentPage: 1, //初始页
      pagesize: 10, // 每页的数据
      searchForm: {
        name: "",
        phone: "",
        type: "0",
      },
      types: types,
      editData: {},
      listShow: true,
      editShow: false,
      delVisible: false,
      dataList: [],
      multipleSelection: [],
      productId: localStorage.getItem("project_Id"),
      labelId: "",
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getType(type) {
      for (var i = 0; i < types.length; i++) {
        if (types[i].value == type) {
          return types[i].name;
        }
      }
      return "其他";
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getData();
    },
    addSubmit() {
      this.labelId = "";
      this.editData = null;
      this.listShow = false;
      this.editShow = true;
    },
    searchSubmit() {
      this.currentPage = 1;
      this.getData();
    },
    handleDelete(index, row) {
      this.labelId = row.labelId;
      this.delVisible = true;
    },
    handleCloseVisible() {
      this.labelId = "";
      this.delVisible = false;
    },
    deleteData() {
      this.$axios.delete(`/Label/${this.labelId}`).then((res) => {
        if (res.data.hasError) {
          this.$message.error(res.data.message);
        } else {
          this.$message.success("删除成功！");
          this.delVisible = false;
          this.searchSubmit();
        }
      });
    },
    // 获取数据
    getData() {
      var search = {
        name: this.searchForm.name,
        pageIndex: this.currentPage - 1,
        pageSize: this.pagesize,
        projectId: this.productId,
        type: parseInt(this.searchForm.type),
      };
      this.$axios.post("/Label/Search", search).then((res) => {
        if (res.data.hasError == false) {
          this.dataList = [...res.data.data];
          this.total = res.data.total;
        }
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleEdit(index, row) {
      this.editData = row;
      this.listShow = false;
      this.editShow = true;
    },
    getFunStu() {
      this.listShow = true;
      this.editShow = false;
      this.getData();
    },
  },
  components: {
    EditSource,
    DeleteDialog,
  },
};
</script>
<style lang="scss" scope>
.pag {
  position: absolute;
  bottom: 0;
}

.table-wrap {
  margin-left: 10px;
  height: 100%;
}

.el-main {
  border-radius: 5px;
  position: relative;
}

.uers-left {
  float: left;
}

.uers-right {
  float: right;
}

.uers-import {
  margin-right: 30px;
  float: right;
  width: 240px;
}

.upload-excel {
  float: left;
}

.import-bnt {
  float: right;
}

.el-upload {
  height: 32px !important;
  line-height: 32px !important;
  width: 120px !important;
}

.el-upload--text {
  border: 0;
}
</style>